import type { Jurisdiction, Position } from '@goldfishcode/kingmakerdata-api-sdk/libs/api/location/models';
import type { GovernmentLevel, Race } from '@goldfishcode/kingmakerdata-api-sdk/libs/api/user/models';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { message } from 'antd';
import { apiIns } from 'src/config/apiClient';

// Thunk for getting government levels
export const getGovernmentLevel = createAsyncThunk<GovernmentLevel[], void>(
  'position/getGovernmentLevel',
  async (_, { rejectWithValue }) => {
    try {
      return await apiIns.user.getGovernmentLevel();
    } catch (error: any) {
      message.error(error.message);
      return rejectWithValue(error.message);
    }
  },
);

// Thunk for getting jurisdictions by state
export const getJurisdiction = createAsyncThunk<Jurisdiction[], string>(
  'position/getJurisdiction',
  async (stateId, { rejectWithValue }) => {
    try {
      return await apiIns.location.getJurisdictions(stateId);
    } catch (error: any) {
      message.error(error.message);
      return rejectWithValue(error.message);
    }
  },
);

// Thunk for getting races by state
export const getRace = createAsyncThunk<Race[], string>('position/getRace', async (stateId, { rejectWithValue }) => {
  try {
    return await apiIns.user.getRace(stateId);
  } catch (error: any) {
    message.error(error.message);
    return rejectWithValue(error.message);
  }
});

// Thunk for getting positions by state
export const getPositions = createAsyncThunk<Position[], string>(
  'position/getPositions',
  async (stateId, { rejectWithValue }) => {
    try {
      return await apiIns.location.getPositions(stateId);
    } catch (error: any) {
      message.error(error.message);
      return rejectWithValue(error.message);
    }
  },
);
